import { toast } from 'react-toastify';
import { headers } from 'src/utils';
import { GetApi, PostApi } from 'src/services/middleware';
import {
  fetchRefreshRulesURL,
  fetchRiskDetailsURL,
  fetchRiskSubDetailsURL
} from '../constants';

export const fetchRiskDetails = async (claimId, subClaimId) => {
  try {
    const res = await GetApi(
      `${fetchRiskDetailsURL(claimId, subClaimId)}`,
      headers()
    );

    if (res?.status == 200) {
      return res?.data?.data;
    }
  } catch (err) {
    toast.error('something went wrong');
  }
};

export const fetchRiskSubDetails = async (id) => {
  try {
    const res = await GetApi(`${fetchRiskSubDetailsURL(id)}`, headers());
    if (res?.status == 200) {
      return res?.data?.data;
    }
  } catch (err) {
    toast.error('something went wrong');
  }
};

export const fetchRefreshRules = async (claimId, subClaimId) => {
  try {
    const res = await GetApi(
      ` ${fetchRefreshRulesURL(claimId, subClaimId)}`,
      headers()
    );
    if (res?.status === 200) {
      toast.success(res?.data?.message);
      return res?.data;
    }
  } catch (err) {
    toast.error('something went wrong');
    throw err;
  }
};
